import { createAction, props } from '@ngrx/store';
import { SimpleUser } from '../../../user-admin/user/models/SimpleUser';
import { Analysis } from '../../models/Analysis';
import { MeasureCatalog } from '../../models/MeasureCatalog';
import { Attachment } from '../../models/attachment/Attachment';
import { Measure } from '../../models/criterions/Measure';
import { DataMM13ElementItem } from '../models/DataMM13ElementItem';
import { MM13OpInstruction } from '../models/MM13OpInstruction';
import { SelectedTreeNode } from '../models/TreeMenu';
import { TrafficLightColor } from '../../models/criterions/TrafficLightColor';
import { MM13Likelyhood } from '../models/MM13Likelyhood';
import { MM13Severity } from '../models/MM13Severity';
import { MM13TemplateType } from 'src/app/masterdata/models/config-version/MM13TemplateType';
import { SystemError } from 'src/app/shared/models/SystemError';
import { ChoiceDTO } from '../models/ChoiceDTO';
import { AnalysisPage } from '../../models/AnalysisPage';
import { RequestPasteCr13Item } from 'src/app/analysis/cr13/models/RequestPasteCr13Item';

export enum ActionTypes {
    SELECTED_TREE_NODE = '[CR13 Page] Select node from tree',
    GET_MEASURE_CATALOG = '[CR13] Loading countermeasure catalog',
    GET_MEASURE_CATALOG_SUCCESS = '[CR13 API] Loaded countermeasure catalog successfully',
    GET_MEASURE_CATALOG_FAIL = '[CR13 API] Failed loading countermeasure catalog',
    VALIDATE_DATA_ITEM_MM13 = '[CR13] Validate Data Item MM13',
    VALIDATE_DATA_ITEM_MM13_SUCCESS = '[CR13 API] Data Item MM13 validated successfully',
    VALIDATE_DATA_ITEM_MM13_FAIL = '[CR13 API] Data Item MM13 validation Failed',
    VALIDATE_MM13_MEASURES_DONE = '[CR13] Validate All the countermeasures on MM13',
    VALIDATE_MM13_MEASURES_DONE_SUCCESS = '[CR13 API] Validate All the countermeasures on MM13 Successfuly',
    VALIDATE_MM13_MEASURES_DONE_FAIL = '[CR13 API] The MM13 countermeasures validation Failed',
    VALIDATE_DATA_ITEM_MM13_ON_APPLY_COUNTER_MEASURES_CHANGE = '[CR13] Validate the Active Item on MM13',
    VALIDATE_DATA_ITEM_MM13_ON_APPLY_COUNTER_MEASURES_CHANGE_SUCCESS = '[CR13 API] The Active Item on MM13 was validated successfully',
    VALIDATE_DATA_ITEM_MM13_ON_APPLY_COUNTER_MEASURES_CHANGE_FAIL = '[CR13 API] Active Item on MM13 Validation Failed',
    UPDATE_ACTIVE_ITEM = '[CR13 Page] Update Active Item',
    UPDATE_ACTIVE_MEASURE = '[CR13 Page] Update Active Measure',
    VALIDATE_ACTIVE_MEASURE_SUCCESS = '[CR13 Page] Validate Active Measure success',
    VALIDATE_ACTIVE_MEASURE_FAIL = '[CR13 Page] Validate Active Measure failed',
    OPEN_NEW_MEASURE_FORM = '[CR13 Page] Open New Countermeasure Form',
    OPEN_EXISTING_MEASURE_FORM = '[CR13 Page] Open Existing Countermeasure Form',
    CLOSE_MEASURE_FORM = '[CR13 Page] Close Countermeasure Form',
    GET_USER = '[CR13 - Create Countermeasure Popup] Getting selected user',
    GET_USER_SUCCESS = '[CR13 - Create Countermeasure Popup] Getting selected user success',
    GET_USER_FAIL = '[CR13 - Create Countermeasure Popup] Getting selected user fail',
    UPDATE_OP_INSTRUCTIONS = '[CR13] Update Op Instruction',
    GET_FILE = '[CR13] Downloading file',
    GET_FILE_SUCCESS = '[CR13 API] File downloaded successfully',
    GET_FILE_FAIL = '[CR13 API] File failed to download',
    GET_CHOICE_INFO = '[CR13 - Choice Popup] Get Choice Data',
    GET_CHOICE_INFO_SUCCESS = '[CR13 - Choice Popup] Get Choice data success',
    GET_CHOICE_INFO_FAIL = '[CR13 - Choice Popup] Get Choice data fail',
    UPDATE_HAZARD_ATTACHMENTS = '[CR13 - Attachments] Updated hazard attachments',
    DELETE_COUNTERMEASURE = '[CR13 - Delete countermeasure] Delete action',
    DELETE_COUNTERMEASURE_IN_HAZARD_TABLE = '[CR13 - Delete countermeasure in hazard table] Delete action',
    RECALC_AFTER_MEASURE_DELETE_SUCCESS = '[CR13 API - Recalc analysis] Recalc analysis after countermeasure deletion success]',
    RECALC_AFTER_MEASURE_DELETE_FAIL = '[CR13 API - Recalc analysis] Recalc analysis after countermeasure deletion failed]',
    APPLY_COUNTERMEASURES_CHANGE_SUCCESS = '[CR13 - Apply countermeasures change] Countermeasures change applied successfully',
    APPLY_COUNTERMEASURES_CHANGE_FAIL = '[CR13 - Apply countermeasures change] Failed to apply countermeasures change',
    DELETE_HAZARD = '[CR13 - Delete Hazard in hazard table] Delete action',
    RECALC_AFTER_HAZARD_DELETE_SUCCESS = '[CR13 API - Recalc analysis] Recalc analysis after hazard deletion success]',
    RECALC_AFTER_HAZARD_DELETE_FAIL = '[CR13 API - Recalc analysis] Recalc analysis after hazard deletion failed]',
    UPDATE_IS_NEW_HAZARD_CREATION = '[CR13 Page] Update isNewHazardCreation boolean',
    UPDATE_ACTIVE_ITEM_FROM_DIRECT_ROUTE = '[CR13 Page] Update Active Item from direct route',
    LOAD_CRITERION_13_COMPONENT = '[CR13 Page] Load Criterion 13 Component',
    UPDATE_ITEM_AND_OPEN_FORM = '[Hazard Table Component] Update Item and Open Form',
    LOAD_INITIAL_DATA_COUNTERMEASURE_FORM = '[Hazard Countermeasure Form Component] Load Initial Data',
    UPDATE_ITEM_AND_OPEN_FORM_FOR_NEW_COUNTERMEASURES = '[Hazard Countermeasure Form Component] Update Item and Open Form for New Countermeasures',
    EXPAND_COLLAPSE_TREE = '[CR13 Page] Expand/Collapse Tree',
    COPY_COUNTERMEASURE_TO_CLIPBOARD = '[CR13 - Copy Paste Clipboard] Copy countermeasure to clipboard',
    COPY_COUNTERMEASURE_TO_CLIPBOARD_SUCCESS = '[CR13 - Copy Paste Clipboard] Copy countermeasure to clipboard success',
    COPY_COUNTERMEASURE_TO_CLIPBOARD_FAIL = '[CR13 - Copy Paste Clipboard] Copy countermeasure to clipboard fail',
    COPY_HAZARD_TO_CLIPBOARD = '[CR13 - Copy Paste Clipboard] Copy hazard to clipboard',
    COPY_HAZARD_TO_CLIPBOARD_SUCCESS = '[CR13 - Copy Paste Clipboard] Copy hazard to clipboard success',
    COPY_HAZARD_TO_CLIPBOARD_FAIL = '[CR13 - Copy Paste Clipboard] Copy hazard to clipboard fail',
    VALIDATE_PASTE_COUNTERMEASURE = '[CR13 - Copy Paste Clipboard] Validate paste countermeasure',
    VALIDATE_PASTE_COUNTERMEASURE_FAIL = '[CR13 - Copy Paste Clipboard] Validate paste countermeasure fail',
    PASTE_COUNTERMEASURE_FROM_CLIPBOARD = '[CR13 - Copy Paste Clipboard] Paste countermeasure to clipboard',
    PASTE_COUNTERMEASURE_FROM_CLIPBOARD_SUCCESS = '[CR13 - Copy Paste Clipboard] Paste countermeasure from clipboard success',
    PASTE_COUNTERMEASURE_FROM_CLIPBOARD_FAIL = '[CR13 - Copy Paste Clipboard] Paste countermeasure from clipboard fail',
    PASTE_COUNTERMEASURE_FROM_CLIPBOARD_AND_UPDATE_ITEM = '[CR13 - Copy Paste Clipboard] Paste countermeasure from clipboard and update active item',
    PASTE_COUNTERMEASURE_FROM_CLIPBOARD_AND_UPDATE_ITEM_SUCCESS = '[CR13 - Copy Paste Clipboard] Paste countermeasure from clipboard and update active item success',
    OPEN_COUNTERMEASURE_RESPONSIBLE_POPUP = '[CR13 - Copy Paste Clipboard] Open countermeasure responsible popup',
    CLOSE_PASTE_COUNTERMEASURE_POPUP = '[CR13 - Copy Paste Clipboard] Close paste countermeasure popup',
    VALIDATE_PASTE_HAZARD = '[CR13 - Copy Paste Clipboard] Validate paste hazard to clipboard',
    VALIDATE_PASTE_HAZARD_SUCCESS = '[CR13 - Copy Paste Clipboard] Validate paste hazard from clipboard success',
    VALIDATE_PASTE_HAZARD_FAIL = '[CR13 - Copy Paste Clipboard] Validate paste hazard from clipboard fail',
    PASTE_HAZARD_FROM_CLIPBOARD = '[CR13 - Copy Paste Clipboard] Paste hazard from clipboard',
    PASTE_HAZARD_FROM_CLIPBOARD_SUCCESS = '[CR13 - Copy Paste Clipboard] Paste hazard from clipboard success',
    PASTE_HAZARD_FROM_CLIPBOARD_FAIL = '[CR13 - Copy Paste Clipboard] Paste hazard from clipboard fail'
}
export const loadCriterion13Component = createAction(ActionTypes.LOAD_CRITERION_13_COMPONENT, props<{ selectedAnalysisPage: AnalysisPage | null }>());

export const treeNodeSelected = createAction(ActionTypes.SELECTED_TREE_NODE, props<{ selectedTreeNode: SelectedTreeNode }>());

export const getMeasureCatalog = createAction(ActionTypes.GET_MEASURE_CATALOG);

export const getMeasureCatalogSuccess = createAction(ActionTypes.GET_MEASURE_CATALOG_SUCCESS, props<{ measureCatalog: MeasureCatalog[] }>());

export const getMeasureCatalogFail = createAction(ActionTypes.GET_MEASURE_CATALOG_FAIL);

export const validateDataItemMM13 = createAction(ActionTypes.VALIDATE_DATA_ITEM_MM13, props<{ changeRoute?: string[]; isNewHazardCreation?: boolean }>());

export const validateDataItemMM13Success = createAction(
    ActionTypes.VALIDATE_DATA_ITEM_MM13_SUCCESS,
    props<{
        changeRoute?: string[];
        hazard: DataMM13ElementItem | null;
        defMM13ElementId: number | undefined;
    }>()
);

export const validateDataItemMM13Fail = createAction(ActionTypes.VALIDATE_DATA_ITEM_MM13_FAIL, props<{ systemError: SystemError }>());

export const validateMM13MeasuresDone = createAction(
    ActionTypes.VALIDATE_MM13_MEASURES_DONE,
    props<{
        measuresDone: boolean;
        remainingRiskAcceptable: boolean;
        noRiskRemaining: boolean;
        isLastTabManuallyChanged: boolean;
        rzValue?: number;
        color?: TrafficLightColor;
        rzValueAfterMeasures?: number;
        colorAfterMeasures?: TrafficLightColor;
        likelyhoodAfter?: MM13Likelyhood;
        severityAfter?: MM13Severity;
        tab?: number;
        templateType?: MM13TemplateType | null;
        value1After?: number | null;
        value2After?: number | null;
        value3After?: number | null;
        value4After?: number | null;
        value5After?: number | null;
        value6After?: number | null;
        boolean1After?: boolean;
        boolean2After?: boolean;
    }>()
);

export const validateMM13MeasuresDoneSuccess = createAction(ActionTypes.VALIDATE_MM13_MEASURES_DONE_SUCCESS);

export const validateMM13MeasuresDoneFail = createAction(ActionTypes.VALIDATE_MM13_MEASURES_DONE_FAIL, props<{ systemError: SystemError }>());

export const validateDataItemMM13OnApplyCounterMeasuresChange = createAction(
    ActionTypes.VALIDATE_DATA_ITEM_MM13_ON_APPLY_COUNTER_MEASURES_CHANGE,
    props<{ changeRoute?: string[]; activeItem: DataMM13ElementItem }>()
);

export const validateDataItemMM13OnApplyCounterMeasuresChangeSuccess = createAction(
    ActionTypes.VALIDATE_DATA_ITEM_MM13_ON_APPLY_COUNTER_MEASURES_CHANGE_SUCCESS,
    props<{
        changeRoute?: string[];
        hazard: DataMM13ElementItem;
        defMM13ElementId: number | undefined;
    }>()
);

export const validateDataItemMM13OnApplyCounterMeasuresChangeFail = createAction(
    ActionTypes.VALIDATE_DATA_ITEM_MM13_ON_APPLY_COUNTER_MEASURES_CHANGE_FAIL,
    props<{ systemError: SystemError }>()
);

export const recalcSingleAnalysisAfterMeasureDeletionSuccess = createAction(
    ActionTypes.RECALC_AFTER_MEASURE_DELETE_SUCCESS,
    props<{ analysis: Analysis; problemId: number | undefined | null; systemMessage: string }>()
);

export const recalcSingleAnalysisAfterMeasureDeletionFail = createAction(ActionTypes.RECALC_AFTER_MEASURE_DELETE_FAIL, props<{ systemError: SystemError }>());

export const recalcSingleAnalysisAfterHazardDeletionSuccess = createAction(
    ActionTypes.RECALC_AFTER_HAZARD_DELETE_SUCCESS,
    props<{ analysis: Analysis; systemMessage: string }>()
);

export const recalcSingleAnalysisAfterHazardDeletionFail = createAction(ActionTypes.RECALC_AFTER_HAZARD_DELETE_FAIL, props<{ systemError: SystemError }>());

export const updateActiveItem = createAction(
    ActionTypes.UPDATE_ACTIVE_ITEM,
    props<{
        activeItem: DataMM13ElementItem | null;
        isNewHazardCreation?: boolean;
    }>()
);
export const deleteCountermeasureInHazardTable = createAction(
    ActionTypes.DELETE_COUNTERMEASURE_IN_HAZARD_TABLE,
    props<{
        problemId: number | undefined | null;
        counterMeasureId: number | undefined | null;
    }>()
);
export const deleteCountermeasure = createAction(
    ActionTypes.DELETE_COUNTERMEASURE,
    props<{
        problemId: number | undefined | null;
        counterMeasureId: number | undefined | null;
    }>()
);

export const deleteHazardInHazardTable = createAction(
    ActionTypes.DELETE_HAZARD,
    props<{
        problemIdentifier: number | undefined | null;
    }>()
);

export const updateActiveMeasure = createAction(
    ActionTypes.UPDATE_ACTIVE_MEASURE,
    props<{
        activeMeasure: Measure;
        templateType: MM13TemplateType | null | undefined;
    }>()
);

export const validateActiveMeasureSuccess = createAction(
    ActionTypes.VALIDATE_ACTIVE_MEASURE_SUCCESS,
    props<{
        hazard: DataMM13ElementItem | null;
        defMM13ElementId: number | undefined;
        systemMessage: string;
    }>()
);

export const validateActiveMeasureFail = createAction(ActionTypes.VALIDATE_ACTIVE_MEASURE_FAIL, props<{ systemError: SystemError }>());

export const openNewCountermeasureForm = createAction(ActionTypes.OPEN_NEW_MEASURE_FORM);

export const openExistingCountermeasureForm = createAction(ActionTypes.OPEN_EXISTING_MEASURE_FORM, props<{ countermeasure: Measure }>());

export const closeCountermeasureForm = createAction(ActionTypes.CLOSE_MEASURE_FORM);

export const getUser = createAction(ActionTypes.GET_USER, props<{ qNumber: string; fieldToBeSet: string }>());

export const getUserSuccess = createAction(ActionTypes.GET_USER_SUCCESS, props<{ user: SimpleUser; fieldToBeSet: string }>());

export const getUserFail = createAction(ActionTypes.GET_USER_FAIL);

export const getFile = createAction(ActionTypes.GET_FILE, props<{ pathContext: string; filename: string }>());

export const getFileSuccess = createAction(ActionTypes.GET_FILE_SUCCESS);

export const getFileFail = createAction(ActionTypes.GET_FILE_FAIL, props<{ systemError: SystemError }>());

export const updateOPInstructions = createAction(ActionTypes.UPDATE_OP_INSTRUCTIONS, props<{ opInstruction: MM13OpInstruction[] }>());

export const getChoiceInfo = createAction(ActionTypes.GET_CHOICE_INFO);

export const getChoiceInfoSuccess = createAction(ActionTypes.GET_CHOICE_INFO_SUCCESS, props<{ choiceData: ChoiceDTO[] }>());

export const getChoiceInfoFail = createAction(ActionTypes.GET_CHOICE_INFO_FAIL, props<{ systemError: SystemError }>());

export const updateHazardAttachments = createAction(ActionTypes.UPDATE_HAZARD_ATTACHMENTS, props<{ attachments: Attachment[] }>());

export const applyCountermeasuresMitigationSuccess = createAction(
    ActionTypes.APPLY_COUNTERMEASURES_CHANGE_SUCCESS,
    props<{ analysis: Analysis; systemMessage: string }>()
);

export const applyCountermeasuresMitigationFail = createAction(ActionTypes.APPLY_COUNTERMEASURES_CHANGE_FAIL, props<{ systemError: SystemError }>());

export const updateIsNewHazardCreation = createAction(ActionTypes.UPDATE_IS_NEW_HAZARD_CREATION, props<{ isNewHazardCreation: boolean }>());

export const updateActiveItemFromDirectRoute = createAction(ActionTypes.UPDATE_ACTIVE_ITEM_FROM_DIRECT_ROUTE, props<{ activeItem: DataMM13ElementItem }>());

export const updateItemAndOpenForm = createAction(
    ActionTypes.UPDATE_ITEM_AND_OPEN_FORM,
    props<{ dataMM13ElementItem: DataMM13ElementItem; measure: Measure }>()
);

export const loadInitialDataForCounterMeasureForm = createAction(ActionTypes.LOAD_INITIAL_DATA_COUNTERMEASURE_FORM);

export const updateItemAndOpenFormForNewCounterMeasure = createAction(
    ActionTypes.UPDATE_ITEM_AND_OPEN_FORM_FOR_NEW_COUNTERMEASURES,
    props<{ dataMM13ElementItem: DataMM13ElementItem; measure: Measure }>()
);

export const expandCollapseTree = createAction(ActionTypes.EXPAND_COLLAPSE_TREE);

export const copyCountermeasureToClipboard = createAction(
    ActionTypes.COPY_COUNTERMEASURE_TO_CLIPBOARD,
    props<{ measure: Measure; defMM13ElementId: number }>()
);

export const copyCountermeasureToClipboardSuccess = createAction(
    ActionTypes.COPY_COUNTERMEASURE_TO_CLIPBOARD_SUCCESS,
    props<{ systemMessage: string; templateType: string | null }>()
);

export const copyCountermeasureToClipboardFail = createAction(ActionTypes.COPY_COUNTERMEASURE_TO_CLIPBOARD_FAIL, props<{ systemError: SystemError }>());

export const copyHazardToClipboard = createAction(ActionTypes.COPY_HAZARD_TO_CLIPBOARD, props<{ hazard: DataMM13ElementItem }>());

export const copyHazardToClipboardSuccess = createAction(
    ActionTypes.COPY_HAZARD_TO_CLIPBOARD_SUCCESS,
    props<{ systemMessage: string; templateType: MM13TemplateType | null; isRiskClassification: boolean }>()
);

export const copyHazardToClipboardFail = createAction(ActionTypes.COPY_HAZARD_TO_CLIPBOARD_FAIL, props<{ systemError: SystemError }>());

export const validatePasteCountermeasure = createAction(
    ActionTypes.VALIDATE_PASTE_COUNTERMEASURE,
    props<{ defId: number; hazardRI: number | undefined; hazardA8: number | undefined }>()
);

export const validatePasteCountermeasureFail = createAction(ActionTypes.VALIDATE_PASTE_COUNTERMEASURE_FAIL, props<{ systemError: SystemError }>());

export const pasteCountermeasureFromClipboard = createAction(
    ActionTypes.PASTE_COUNTERMEASURE_FROM_CLIPBOARD,
    props<{ hazardId: number; data: RequestPasteCr13Item }>()
);

export const pasteCountermeasureFromClipboardSuccess = createAction(
    ActionTypes.PASTE_COUNTERMEASURE_FROM_CLIPBOARD_SUCCESS,
    props<{ hazardId: number; measure: Measure; systemMessage: string }>()
);

export const pasteCountermeasureFromClipboardFail = createAction(ActionTypes.PASTE_COUNTERMEASURE_FROM_CLIPBOARD_FAIL, props<{ systemError: SystemError }>());

export const pasteCountermeasureFromClipboardAndUpdateActiveItem = createAction(
    ActionTypes.PASTE_COUNTERMEASURE_FROM_CLIPBOARD_AND_UPDATE_ITEM,
    props<{ hazardId: number; data: RequestPasteCr13Item }>()
);

export const pasteCountermeasureFromClipboardAndUpdateActiveItemSuccess = createAction(
    ActionTypes.PASTE_COUNTERMEASURE_FROM_CLIPBOARD_AND_UPDATE_ITEM_SUCCESS,
    props<{ hazardId: number; measure: Measure; systemMessage: string }>()
);

export const openCountermeasuresResponsiblePopup = createAction(ActionTypes.OPEN_COUNTERMEASURE_RESPONSIBLE_POPUP);

export const closeCountermeasuresResponsiblePopup = createAction(ActionTypes.CLOSE_PASTE_COUNTERMEASURE_POPUP);

export const validatePasteHazard = createAction(ActionTypes.VALIDATE_PASTE_HAZARD);

export const validatePasteHazardSuccess = createAction(ActionTypes.VALIDATE_PASTE_HAZARD_SUCCESS, props<{ hasMeasures: boolean }>());

export const validatePasteHazardFail = createAction(ActionTypes.VALIDATE_PASTE_HAZARD_FAIL, props<{ systemError: SystemError }>());

export const pasteHazardFromClipboard = createAction(ActionTypes.PASTE_HAZARD_FROM_CLIPBOARD, props<{ data: RequestPasteCr13Item }>());

export const pasteHazardFromClipboardSuccess = createAction(
    ActionTypes.PASTE_HAZARD_FROM_CLIPBOARD_SUCCESS,
    props<{ hazard: DataMM13ElementItem; systemMessage: string }>()
);

export const pasteHazardFromClipboardFail = createAction(ActionTypes.PASTE_HAZARD_FROM_CLIPBOARD_FAIL, props<{ systemError: SystemError }>());
